import moment from 'moment'
import api from '@/services/api'

export const getStagesFromApi = async () => {
    const today = moment().format('YYYY-MM-DD')
    try {
        const resp = await api.get('/periods/all/events', {
            params: {
                sortedBy: 'asc',
                orderBy: 'start_date',
                search: `period.start_date:${today};period.end_date:${today};event_type:stage_definition`,
                and: 'yes',
            },
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
    }
}
